import translationPt from './translationPt';
import translationEn from './translationEn';
import translationSp from './translationSp';

const translations = {
	1: translationPt,
	2: translationEn,
	3: translationSp,
};

export default translations;

export function translate(language) {
	return translations[language.id];
}



// WEBPACK FOOTER //
// ./src/assets/translations.js